import {
  ADD_DATA,
  GET_ALL_DATA,
  UPDATE_DATA,
  DELETE_DATA,
  GET_ALL_DATA2,
  GET_VENDOR_GROUP,
  SAVE_VENDOR_IDEATION,
  EDIT_VENDOR_IDEATION,
  SEND_RFI_EMAIL,
} from "@/api/master/vendor";
import querystring from "query-string";

const state = {
  list: [],
  list_eksternal: [],
  vendorGroup: [],
  detail: {},
};

const mutations = {
  SET_LIST: (state, payload) => {
    state.list = payload;
  },
  SET_VENDOR_GROUP: (state, payload) => {
    state.vendorGroup = payload;
  },
  SET_LIST_EKSTERNAL: (state, payload) => {
    state.list_eksternal = payload;
  },
};

const actions = {
  GET_LIST: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_ALL_DATA(params);
    const data = resp.data.data;
    commit("SET_LIST", data);
  },

  GET_VEN_GROUP: async ({ commit }) => {
    // params = querystring.stringify(params);
    const resp = await GET_VENDOR_GROUP();
    const data = resp.data.data;
    commit("SET_VENDOR_GROUP", data);
  },

  GET_LIST_EKSTERNAL: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_ALL_DATA2(params);
    const data = resp.data.data;
    commit("SET_LIST_EKSTERNAL", data);
  },

	CREATE_DATA: async ({ commit }, args) => {
		return await ADD_DATA(args);
	},

  SAVE_VENDOR_IDEATION: async ({ commit }, args) => {
		return await SAVE_VENDOR_IDEATION(args);
	},

  SEND_RFI_EMAIL: async ({ commit }, args) => {
		return await SEND_RFI_EMAIL(args);
	},

	UPDATE_DATA: async ({ }, args) => {
		return await UPDATE_DATA(args);
	},

  EDIT_VENDOR_IDEATION: async ({ }, args) => {
		return await EDIT_VENDOR_IDEATION(args);
	},

	DELETE_DATA: async ({ }, id) => {
		return await DELETE_DATA(id);
	},
	// CREATE_DATA: async ({ commit }, args) => {
	// 	var id = state.list.length + 1
	// 	args.id = id
	// 	state.list.push(args)
	// 	// return await ADD_DATA(args);
	// },
	// UPDATE_DATA: async ({ commit }, args) => {
	// 	state.list.forEach(item => {
	// 		if (item.id == args.id) {
	// 			// console.log(args)
	// 			commit("UPDATE_DATA", args)
	// 		}
	// 	})
	// 	// return await UPDATE_DATA(args);
	// },

	// DELETE_DATA: async ({ }, id) => {
	// 	state.list.forEach((data, i) => {
	// 		if (data.id == id) {
	// 			state.list.splice(i, 1);
	// 		}
	// 	})
	// 	// return await DELETE_DATA(id);
	// },
};

const getters = {
  list: (state) => state.list,
  list_eksternal: (state) => state.list_eksternal,
  list_vendor_group: (state) => state.vendorGroup,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
